import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationModel } from 'common/models/page-models/notification/notification-data.model';
import { ResolverResponseModel } from 'common/models/utility-models/base-model';
import { SmCheckboxModel } from 'common/models/utility-models/meta-model';

import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { NotificationFormWidgetService } from 'common/widget/notification/notification-form-widget.service';


@Injectable({
    providedIn: 'root'
})
export class NotificationFormResolver extends FormResolverService<NotificationModel> {
    constructor(
        protected fs: NotificationFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

   

    override modifyResponseData(dataModel) {
        const zoneNames = this.systemService.dataStorage.zone_name;
        for (const zone of zoneNames) {
            dataModel[zone.zone_name] = '';
        }
        return dataModel;
    }


    override getMetaForComponent() {
        const meta = this.pageService.getMetaModel();
        const zoneNames = this.systemService.dataStorage.zone_name;
        const directionCheckboxes = {};
        for (const zone of zoneNames) {
            directionCheckboxes[zone.zone_name] = new SmCheckboxModel(
                zone.zone_name,
                zone.zone_name,
                'checkbox',
                false,
                'col-6 col-md-1',
                1,
                8,
                zone.zone_name.charAt(0).toUpperCase() + zone.zone_name.slice(1),
                'checkbox',
                '',
                false,
                true,
                true,
                false,
                0,
                0,
                false,
                false
                
                
            );
        }
        meta.properties = {
            ...meta.properties,
            ...directionCheckboxes
        };
        return meta;
    }
}
